import dotenv from "dotenv";
dotenv.config();

export const config = {
    adentis: {
        host: process.env.REACT_APP_MICROSOFT_ADENTIS_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_ADENTIS_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_ADENTIS_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_ADENTIS_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_ADENTIS_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_ADENTIS_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_ADENTIS_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_ADENTIS_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_ADENTIS_ISSUER,
        }
    },
    bee: {
        host: process.env.REACT_APP_MICROSOFT_BEE_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_BEE_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_BEE_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_BEE_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_BEE_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_BEE_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_BEE_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_BEE_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_BEE_ISSUER,
        }
    },
    codewin: {
        host: process.env.REACT_APP_MICROSOFT_CODEWIN_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_CODEWIN_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_CODEWIN_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_CODEWIN_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_CODEWIN_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_CODEWIN_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_CODEWIN_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_CODEWIN_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_CODEWIN_ISSUER,
        }
    },
    teamit: {
        host: process.env.REACT_APP_MICROSOFT_TEAMIT_HOST,
        companyId: process.env.REACT_APP_MICROSOFT_TEAMIT_COMPANY_ID,
        microsoft: {
            authority: process.env.REACT_APP_MICROSOFT_AUTHORITY,
            clientId: process.env.REACT_APP_MICROSOFT_TEAMIT_CLIENT_ID,
            redirectUri: process.env.REACT_APP_MICROSOFT_TEAMIT_REDIRECT_URI,
            tenantId: process.env.REACT_APP_MICROSOFT_TEAMIT_TENANT_ID,
            enable: process.env.REACT_APP_MICROSOFT_TEAMIT_ENABLE
        },
        okta: {
            clientId: process.env.REACT_APP_OKTA_TEAMIT_CLIENT_ID,
            redirectUri: process.env.REACT_APP_OKTA_TEAMIT_REDIRECT_URI,
            issuer: process.env.REACT_APP_OKTA_TEAMIT_ISSUER,
        }
    },
    loginPage: process.env.REACT_APP_LOGIN_PAGE,
    enable: process.env.REACT_APP_LOGIN_PAGE_ENABLE
};
